__turbopack_context__.v({
  "footer": "PlasmicFooter-module__pLZiNq__footer",
  "freeBox__dd7Xw": "PlasmicFooter-module__pLZiNq__freeBox__dd7Xw",
  "freeBox__lLcOw": "PlasmicFooter-module__pLZiNq__freeBox__lLcOw",
  "freeBox__x5Db": "PlasmicFooter-module__pLZiNq__freeBox__x5Db",
  "link": "PlasmicFooter-module__pLZiNq__link",
  "svg": "PlasmicFooter-module__pLZiNq__svg",
  "text___1XnZm": "PlasmicFooter-module__pLZiNq__text___1XnZm",
  "text__iOu2B": "PlasmicFooter-module__pLZiNq__text__iOu2B",
  "text__njLx5": "PlasmicFooter-module__pLZiNq__text__njLx5",
  "text__rbp3E": "PlasmicFooter-module__pLZiNq__text__rbp3E",
});
